import { render, staticRenderFns } from "./generic-api-page.vue?vue&type=template&id=41a4ae9e&scoped=true&lang=html&"
import script from "./generic-api-page.vue?vue&type=script&lang=js&"
export * from "./generic-api-page.vue?vue&type=script&lang=js&"
import style0 from "./generic-api-page.vue?vue&type=style&index=0&id=41a4ae9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a4ae9e",
  null
  
)

component.options.__file = "generic-api-page.vue"
export default component.exports